import { captureInSentryWithDetails } from '@/utilities/captureInSentryWithDetails';

export type Level =
  | typeof console.error
  | typeof console.warn
  | typeof console.info
  | typeof console.debug;

export function logError(
  message: string,
  error: unknown,
  data: Record<string, unknown>,
  // `error` is our default log level; this ensures its logged locally.
  // eslint-disable-next-line no-console
  level: Level = console.error,
) {
  level(message, error, data);
  const tags = Object.entries(data).reduce((state, [key, value]) => {
    // `state` is specifically created for mutation.
    // eslint-disable-next-line no-param-reassign
    state[key] = JSON.stringify(value, null, 2);
    return state;
  }, {} as Record<string, string | number | boolean | null>);
  captureInSentryWithDetails(error, {
    message,
    ...tags,
  });
}
